import { FieldProps, Fields } from "components/controls/FormControl";
import { EntityState } from "components/state/entity";
import { Container } from "components/state/types";
import { BoundActions } from "react-sweet-state";
import { MemberApplicationFormState } from "../entity";
import { ApplicationState, isFormState } from "../store";
import { buildFormControlProps } from "components/controls/FormControl";

const sexItems = {
    "M": 'Muž',
    "F": 'Žena'
};

const formFields: Fields = {

    'member.surname': {
        label: 'Příjmení',
    },

    'member.name': {
        label: 'Jméno',
    },
    'member.title': {
        label: 'Titul',
    },
    'member.birthDate': {
        label: 'Datum narození',
    },
    'member.sex': {
        label: 'Pohlaví',
        placeholder: '- vyberte -',
    },
    'member.personalIdNumber': {
        label: 'Rodné číslo',
    },
    'member.country': {
        label: 'Státní příslušnost',
        placeholder: '- vyberte -',
    },
    'member.homeAddress.street': {
        label: 'Ulice',
    },
    'member.homeAddress.city': {
        label: 'Obec',
    },
    'member.homeAddress.zipCode': {
        label: 'Psč',
    },
    'member.homeAddress.post': {
        label: 'Pošta',
    },
    'member.homePhone': {
        label: 'Tel. domů',
    },
    'member.employerPhone': {
        label: 'Tel. do zaměstnání',
    },
    'member.mobilePhone': {
        label: 'Telefon',
    },
    'member.email': {
        label: 'Email',
    },
    'member.ownedIdt': {
        label: 'Identifikační číslo člena (IDT)',
        note: 'nepovinné, zadejte pouze v případě, že máte IDT přidělené'
    },
    'member.postAddress.street': {
        label: 'Ulice',
    },
    'member.postAddress.city': {
        label: 'Obec',
    },
    'member.postAddress.zipCode': {
        label: 'Psč',
    },
    'member.postAddress.post': {
        label: 'Pošta',
    },
    'legalRepresentative.surname': {
        label: 'Příjmení',
    },
    'legalRepresentative.name': {
        label: 'Jméno',
    },
    'legalRepresentative.title': {
        label: 'Titul',
    },
    'legalRepresentative.birthDate': {
        label: 'Datum narození',
    },
    'legalRepresentative.homeAddress.street': {
        label: 'Ulice',
    },
    'legalRepresentative.homeAddress.city': {
        label: 'Obec',
    },
    'legalRepresentative.homeAddress.zipCode': {
        label: 'Psč',
    },
    'legalRepresentative.homeAddress.post': {
        label: 'Pošta',
    },
    'legalRepresentative.homePhone': {
        label: 'Tel. domů',
    },
    'legalRepresentative.employerPhone': {
        label: 'Tel. do zaměstnání',
    },
    'legalRepresentative.mobilePhone': {
        label: 'Telefon',
    },
    'legalRepresentative.email': {
        label: 'Email',
    },
    'legalRepresentative.postAddress.street': {
        label: 'Ulice',
    },
    'legalRepresentative.postAddress.city': {
        label: 'Obec',
    },
    'legalRepresentative.postAddress.zipCode': {
        label: 'Psč',
    },
    'legalRepresentative.postAddress.post': {
        label: 'Pošta',
    },

    'statutesAgreement': {
        label: "souhlasím s posláním, cíli a úkoly ČSTS, chci se aktivně podílet na jejich realizaci a zavazuji se dodržovat stanovy a ostatní dokumenty ČSTS.",
    },

    'verificationAgreement': {
        label: "souhlasím s ověřením své osoby pomocí emailu a SMS.",
    },

    'memberPostAddressIsSameAsHome': {
        label: '',
        defaultValue: true
    },
    'legalRepHomeAddressIsSameAsMember': {
        label: '',
        defaultValue: true,
    },
    'legalRepPostAddressIsSameAsHome': {
        label: '',
        defaultValue: true
    },
    'accoumtEmailChoose': {
    },
    'hasLegalReprsentative': {
        label: '',
        defaultValue: true
    },


}

const formInputProps = (
    name: string,
    state: ApplicationState,
    actions: BoundActions<EntityState<any>, Container>): FieldProps => {

    const fieldDef = buildFormControlProps(name, formFields, state, actions);

    switch (name) {

        case "accoumtEmailChoose":
            fieldDef.setter = (_: string, v: string) => {
                actions.setFormState(MemberApplicationFormState.LoggedUserIsSameAsMember, v === 'A');
                actions.setFormState(MemberApplicationFormState.LoggedUserIsOtherMember, v === 'B');
            }
            fieldDef.getter = () => isFormState(state as ApplicationState, MemberApplicationFormState.LoggedUserIsSameAsMember) ? 'A'
                : isFormState(state as ApplicationState, MemberApplicationFormState.LoggedUserIsOtherMember) ? 'B'
                    : '';
            break;

        case "statutesAgreement":
            fieldDef.setter = (_: string, v: boolean) => actions.setFormState(MemberApplicationFormState.StatutesAgreement, v);
            fieldDef.getter = () => isFormState(state as ApplicationState, MemberApplicationFormState.StatutesAgreement);
            break;

        case "verificationAgreement":
            fieldDef.setter = (_: string, v: boolean) => actions.setFormState(MemberApplicationFormState.VerificationAgreement, v);
            fieldDef.getter = () => isFormState(state as ApplicationState, MemberApplicationFormState.VerificationAgreement);
            break;

        case "memberPostAddressIsSameAsHome":
            fieldDef.setter = (_: string, v: boolean) => actions.setFormState(MemberApplicationFormState.MemberPostAddressIsSameAsHome, !v);
            fieldDef.getter = () => !isFormState(state as ApplicationState, MemberApplicationFormState.MemberPostAddressIsSameAsHome);
            break;

        case "legalRepHomeAddressIsSameAsMember":
            fieldDef.setter = (_: string, v: boolean) => actions.setFormState(MemberApplicationFormState.LegalRepHomeAddressIsSameAsMember, !v);
            fieldDef.getter = () => !isFormState(state, MemberApplicationFormState.LegalRepHomeAddressIsSameAsMember);
            break;

        case "legalRepPostAddressIsSameAsHome":
            fieldDef.setter = (_: string, v: boolean) => actions.setFormState(MemberApplicationFormState.LegalRepPostAddressIsSameAsHome, !v);
            fieldDef.getter = () => !isFormState(state, MemberApplicationFormState.LegalRepPostAddressIsSameAsHome);
            break;

        case "hasLegalReprsentative":
            fieldDef.setter = (_: string, v: boolean) => actions.setFormState(MemberApplicationFormState.HasLegalRepresentative, v);
            fieldDef.getter = () => isFormState(state, MemberApplicationFormState.HasLegalRepresentative);
            break;
    }

    return fieldDef;
}

export {
    formInputProps,
    sexItems
}